export const MS_IN_DAY = 1000 * 60 * 60 * 24;
export const FORMAT_NAMES = [
  ['день', 'дней', 'день', 'дня'],
  ['капсула', 'капсул', 'капсула', 'капсулы'],
  ['таблетка', 'таблеток', 'таблетка', 'таблетки'],
  ['саше', 'саше', 'саше', 'саше'],
  ['спрей', 'спреев', 'спрей', 'спрея'],
  ['ампула', 'ампул', 'ампула', 'ампулы'],
  ['капли', 'капель', 'капля', 'капли'],
  ['таблетка под язык', 'таблеток под язык', 'таблетка под язык', 'таблетки под язык'],
  ['раствор', 'растворов', 'раствор', 'раствора'],
  ['таблетки шипучие', 'таблеток шипучих', 'таблетка шипучая', 'таблетки шипучие'],
  ['чайная ложка', 'чайных ложек', 'чайная ложка', 'чайные ложки'],
  ['мерная ложка', 'мерных ложек', 'мерная ложка', 'мерные ложки'],
  ['таблетка жевательная', 'таблеток жевательных', 'таблетка жевательная', 'таблетки жевательные'],
  ['батончик', 'батончиков', 'батончик', 'батончика'],
  ['стакан', 'стаканов', 'стакан', 'стакана'],
];
export const CALENDAR_DAY_ABBR = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const USER_ROLE_PATIENT = 'ROLE_PATIENT';
export const USER_ROLE_ADMIN = 'ROLE_ADMIN';
export const USER_ROLE_DOCTOR = 'ROLE_DOCTOR';
export const USER_ROLE_NURSE = 'ROLE_NURSE';
export const USER_ROLE_ASSISTANT = 'ROLE_ASSISTANT';
